import React, { useState, useEffect, useMemo } from 'react'
import ReactDataTableBootstrap from '../../Components/ReactDataTableBootstrap/ReactDataTableBootstrap';
import Controllers from '../../Api/Controllers';
import CategoryProductForm from './CategoryProductForm'
import { toast } from 'react-toastify';
import Helpers from '../../Components/Helpers/Helpers';
import SweetAlert from '../../Components/SweetAlert/SweetAlert'
import { StatusPill, ActionIconButton, ListPageShell, SideDrawer, EmptyState } from '../../Components/Ui'

const CategoryProduct = ({ nameSingle, namePlural, separator }) => {
    const [isProcessing, setIsProccesing] = useState(true)
    const [modalShow, setModalShow] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    const [reload, setReload] = useState(true);
    const [rows, setRows] = useState([])
    const [loadSubmit, setLoadSubmit] = useState(false)
    const [dataUpdated, setDataUpdated] = useState({})
    const [showConfirmDelete, setShowConfirmDelete] = useState(false)
    const [loadSubmitDelete, setLoadSubmitDelete] = useState(false)
    const [dataDeleted, setDataDeleted] = useState({})
    const [localSearch, setLocalSearch] = useState('')
    const [tableFilter, setTableFilter] = useState('')

    useEffect(() => {
        if (reload) {
            setIsProccesing(true)
            Controllers.category_product.get_category_product().then(res => {
                setRows(res.data)
            }).catch(req => Helpers.promise.catch({ req, toast }))
            .finally(() => {
                setIsProccesing(false)
                setReload(false)
            })
        }
    }, [reload])

    const handleInsertUpdate = ({ data }) => {
        setLoadSubmit(true)
        Controllers.category_product.category_product_insert_update(data).then(res => {
            Helpers.toast.construct({ ...res, toast })
            if (res.response === 'success') {
                setModalShow(false)
                setDataUpdated({})
            }
        }).catch(req => Helpers.promise.catch({ req, toast }))
        .finally(() => {
            setLoadSubmit(false)
            setReload(true)
        })
    }

    const handleGet = e => {
        let $this = e.currentTarget

        if (!$this.dataset?.idCategoryProduct) {
            setModalTitle(`Registrar ${nameSingle}`)
            setDataUpdated({})
            setModalShow(true);
            return
        }

        let buttonHTML = $this.innerHTML;
        $this.innerHTML = '<i class="fa fa-circle-notch fa-spin"></i>'
        let { idCategoryProduct } = $this.dataset

        Controllers.category_product.get_category_product_id({ p_id_category_product: idCategoryProduct }).then(res => {
            setModalTitle(`Modificar ${nameSingle} #${idCategoryProduct}`)
            setDataUpdated({ data: res.data })
            setModalShow(true);
        }).catch(req => {
            Helpers.promise.catch({ req, toast })
            setReload(true)
        })
        .finally(() => $this.innerHTML = buttonHTML)
    }

    const handleOpenCreate = () => {
        setModalTitle(`Registrar ${nameSingle}`)
        setDataUpdated({})
        setModalShow(true)
    }

    const handleDelete = () => {
        setLoadSubmitDelete(true)

        Controllers.category_product.category_product_delete(dataDeleted).then(res => {
            Helpers.toast.construct({ ...res, toast })
            if (res.response === 'success') {
                setShowConfirmDelete(false)
                setDataDeleted({})
            }
        }).catch(req => Helpers.promise.catch({ req, toast }))
        .finally(() => {
            setReload(true)
            setLoadSubmitDelete(false)
        })
    }

    const handleHideModalForm = () => {
        setModalShow(false)
        setLoadSubmit(false)
    }

    const handleShowModalDelete = e => {
        let { idCategoryProduct, nameCategoryProduct } = e.currentTarget.dataset
        setDataDeleted({
            p_id_category_product: idCategoryProduct,
            p_name_category_product: nameCategoryProduct
        })
        setShowConfirmDelete(true)
    }

    const handleHideModalDelete = () => setShowConfirmDelete(false)

    const applySearch = () => setTableFilter(localSearch)

    const dtRows = useMemo(() => <ReactDataTableBootstrap
        textFilter={tableFilter}
        hideSearch
        head={[
            [
                { name: 'id_category_product', text: 'ID', align: 'center' },
                { name: 'name_category_product', text: 'Descripción' },
                { name: 'state_category_product', text: 'Estado', align: 'center', render: r => <StatusPill tone={parseInt(r.state_category_product) === 1 ? 'success' : 'danger'}>
                    {parseInt(r.state_category_product) === 1 ? 'Activo' : 'Inactivo'}
                </StatusPill> },
                { name: 'actions', text: 'Acciones', align: 'center', render: u => {
                    return <div className="sp-row-actions">
                        <ActionIconButton tone="ghost" icon="fa fa-pen" label="Editar" data-id-category-product={u.id_category_product} onClick={handleGet} />
                        <ActionIconButton tone="danger" icon="fa fa-trash" label="Eliminar" data-id-category-product={u.id_category_product} data-name-category-product={u.name_category_product} onClick={handleShowModalDelete} />
                    </div>
                } },
            ],
        ]}
        rows={rows}
        isProcessing={isProcessing}
    />, [rows, isProcessing, tableFilter])

    const showEmpty = !isProcessing && rows.length === 0

    return <>
        <ListPageShell
            eyebrow="Super Papelera — Espacio de trabajo"
            title={`Listado de ${namePlural}`}
            subtitle="Administra las categorías de producto y su disponibilidad."
            badge="Actividad actualizada"
            primaryAction={
                <ListPageShell.PrimaryButton onClick={handleOpenCreate} icon="fa fa-plus">
                    Registrar {nameSingle}
                </ListPageShell.PrimaryButton>
            }
            onSearch={applySearch}
            filters={[
                {
                    label: 'Buscar',
                    control: (
                        <input
                            type="search"
                            placeholder="Categoría…"
                            value={localSearch}
                            onChange={e => setLocalSearch(e.target.value)}
                            onKeyDown={e => { if (e.key === 'Enter') applySearch() }}
                        />
                    )
                }
            ]}
        >
            {showEmpty ? (
                <EmptyState
                    icon="fa fa-folder"
                    title={`No hay ${namePlural.toLowerCase()} para mostrar`}
                    text="Ajusta la búsqueda o registra una nueva categoría de producto."
                    action={
                        <ListPageShell.PrimaryButton onClick={handleOpenCreate}>
                            Registrar {nameSingle}
                        </ListPageShell.PrimaryButton>
                    }
                />
            ) : (
                <div className="sp-table-wrap">{dtRows}</div>
            )}
        </ListPageShell>

        <SideDrawer
            open={modalShow}
            onClose={handleHideModalForm}
            title={modalTitle}
            subtitle="Los cambios se guardan al confirmar el formulario."
        >
            <CategoryProductForm onSubmit={handleInsertUpdate} loadSubmit={loadSubmit} {...dataUpdated} />
        </SideDrawer>

        <SweetAlert
            icon="delete"
            show={showConfirmDelete}
            showCancelButton
            title={<>¿Desea eliminar {separator} {nameSingle}?</>}
            subtitle={<>#{dataDeleted.p_id_category_product} - {dataDeleted.p_name_category_product}</>}
            confirmButtonText="¡Sí, eliminar!"
            cancelButtonText="¡No!"
            loadSubmit={loadSubmitDelete}
            onCancel={handleHideModalDelete}
            onConfirm={handleDelete}
        />
    </>
}

export default CategoryProduct
